import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PdfSlideshow = ({
  file,
  expandLabel = 'View Presentation',
  collapseLabel = 'Collapse Presentation',
}) => {
  const [expanded, setExpanded] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(800);

  useEffect(() => {
    const updateWidth = () => {
      const maxWidth = 900;
      const padding = 48;
      setPageWidth(Math.min(maxWidth, window.innerWidth - padding));
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  const previewWidth = Math.min(520, pageWidth);

  const handleExpand = () => {
    setExpanded(true);
  };

  const handleCollapse = () => {
    setExpanded(false);
  };

  return (
    <div className={`pdf-slideshow ${expanded ? 'pdf-slideshow-expanded' : 'pdf-slideshow-collapsed'}`}>
      {expanded && (
        <button
          type="button"
          className="btn btn-secondary pdf-slideshow-toggle pdf-slideshow-collapse"
          onClick={handleCollapse}
        >
          {collapseLabel}
        </button>
      )}

      <Document
        file={file}
        onLoadSuccess={({ numPages: totalPages }) => setNumPages(totalPages)}
        loading={<div className="pdf-slideshow-status">Loading presentation...</div>}
        error={<div className="pdf-slideshow-status pdf-slideshow-error">Unable to load PDF.</div>}
      >
        {!expanded && numPages && (
          <>
            <div className="pdf-slideshow-preview">
              <Page
                pageNumber={1}
                width={previewWidth}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
              <div className="pdf-slideshow-preview-fade" aria-hidden="true" />
            </div>
            <button
              type="button"
              className="btn btn-primary pdf-slideshow-toggle"
              onClick={handleExpand}
            >
              {expandLabel}
              {numPages > 1 && (
                <span className="pdf-slideshow-page-count">{numPages} slides</span>
              )}
            </button>
          </>
        )}

        {expanded &&
          numPages &&
          Array.from({ length: numPages }, (_, index) => (
            <Page
              key={`page-${index + 1}`}
              pageNumber={index + 1}
              width={pageWidth}
              renderTextLayer
              renderAnnotationLayer
            />
          ))}
      </Document>
    </div>
  );
};

export default PdfSlideshow;
